module.exports = "https://static.zego.com/_next/static/images/Aviva-3765212c3de326828d70341f22031c5e.svg";